import React, { useEffect } from "react";
import { connect } from "react-redux";
import { get } from "lodash";

import { getMyHistoryGraph } from "../../../store/actions";
import ReactLineChart from "../../../sharedComponents/reactLineChart";

const MyHistoryGraph = ({ getMyHistoryGraph, myHistoryGraphList, title }) => {
	useEffect(() => {
		getMyHistoryGraph();
	}, [getMyHistoryGraph]);

	return (
		<React.Fragment>
			{myHistoryGraphList && myHistoryGraphList.chart_title ? (
				<div className="block block-primary p-3">
					<h4 className="text-primary-dark mb-3">{title ? title : myHistoryGraphList.chart_title}</h4>
					<ReactLineChart
						data={{
							data_categories: myHistoryGraphList.data_categories,
							data_series: myHistoryGraphList.data_series
						}}
						fill={false}
						height={40}
					/>
				</div>
			) : null}
		</React.Fragment>
	);
};

const mapDispatchToProps = { getMyHistoryGraph };

const mapSateToProps = (state) => {
	const { MyProgress } = state;
	return {
		myHistoryGraphList: get(MyProgress, "myHistoryGraphResult", [])
	};
};
export default connect(
	mapSateToProps,
	mapDispatchToProps
)(MyHistoryGraph);
